import React from 'react';
import { Spacer, Flex, Text, BADI_COLORS } from '@badi/badi-components';
import { BlockWrapper, InfoButton } from '../styled-components';
import Image from 'components/Image/Image';
import { translate } from 'base/shared/Localization';

const BadiPlusBookingSummary = ({ infoClickHandler, price }) => (
  <BlockWrapper>
    <Spacer top={2}>
      <InfoButton onClick={infoClickHandler}>
        <Flex dataQa="badi-plus-booking-summary-payment" gutter={0.3} justify="flexStart">
          <Text body="14-Regular">{translate(`booking.summary.payment_info`)}</Text>
          <Image alt="info" src="/assets/icons/info_black.svg" />
        </Flex>
      </InfoButton>
    </Spacer>
    <Spacer top={2}>
      <Flex dataQa="badi-plus-booking-summary-payment-info" gutter={0.3} justify="flexStart">
        <Spacer top={1}>
          {price?.paymentBreakdown?.installments && (
            <BlockWrapper>
              <Text body="14-Bold">
                {price.paymentBreakdown.installments.title}:{' '}
                {price.paymentBreakdown.installments.total}
              </Text>

              <Spacer bottom={1}>
                <Text body="12-Regular">{price.paymentBreakdown.installments.info}</Text>
              </Spacer>
            </BlockWrapper>
          )}
        </Spacer>
      </Flex>

      <Spacer top={2}>
        <Flex direction="column" dataQa="" gutter={0.3} justify="flexStart">
          {price?.paymentBreakdown?.installments?.payments &&
            price.paymentBreakdown.installments.payments.map((payment) => {
              return (
                <BlockWrapper>
                  <Spacer top={1}>
                    <Text body="14-Bold">
                      {' '}
                      {payment.title}: {payment.total}
                    </Text>
                  </Spacer>
                  {payment.info && (
                    <Spacer bottom={1}>
                      <Text body="12-Regular"> {payment.info}</Text>
                    </Spacer>
                  )}
                  {payment.sub_payments.map((obj, i) => (
                    <Spacer bottom={0.5} key={i} left={2}>
                      <Text body="14-Regular">
                        • {obj.title}: {obj.amount}
                      </Text>
                    </Spacer>
                  ))}
                </BlockWrapper>
              );
            })}
        </Flex>
      </Spacer>
      {price?.paymentBreakdown?.total && (
        <Spacer top={2}>
          <Flex dataQa="" gutter={0.3} justify="spaceBetween">
            <Text body="14-Bold">Total Accomodation:</Text>

            <Text body="14-Bold">{price?.paymentBreakdown?.total}</Text>
          </Flex>
        </Spacer>
      )}
    </Spacer>
  </BlockWrapper>
);

export default BadiPlusBookingSummary;
